const siteOptionData = [
    {
      id: 1,
      siteName: "BLOODLINE DEV",
      image:
        "https://i.ibb.co/1RF1Gfq/favicon.png",
      description: "Experience a secure and reliable VPN service with enhanced privacy and performance.",
      siteLink: "https://sumsag-ultra.site/"
    }
  ];
  export default siteOptionData;
